export default __webpack_public_path__ + "static/media/21_photo.dea40eed.jpg";